import React from 'react';
import ent from 'ent';

const Raw = ({component = 'div', content = '', ...rest}) => {
    const raw = ent.decode(content);
    return React.createElement(component, {
        dangerouslySetInnerHTML: {__html: raw},
        ...rest,
    });
};

export default Raw;
